import { create } from 'zustand';

type HealthManagementMode = 'complex' | 'manufacturer_lifespan';

interface CompanyStore {
  healthManagementMode: HealthManagementMode | null;
  isLoading: boolean;
  setHealthManagementMode: (mode: HealthManagementMode) => void;
  reset: () => void;
}

export const useCompanyStore = create<CompanyStore>((set) => ({
  healthManagementMode: null,
  isLoading: false,

  setHealthManagementMode: (mode) => {
    set({ healthManagementMode: mode });
  },

  reset: () => {
    set({
      healthManagementMode: null,
      isLoading: false,
    });
  },
}));
